/* Venisons Heritage 2026, Product Card Colour Track JS */
/*
 * Drives the colour photo track on collection/search product cards.
 * Event delegation on document only, no per-card listeners, so this also
 * works for cards injected later by collection-filters.js re-renders or
 * search results. Guards everything on the presence of .product-card-track,
 * single-colour cards never have one.
 */

(function () {
  'use strict';

  var RESTORE_DELAY = 150;
  var pointerFine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var restoreTimers = new WeakMap();

  function getCard(el) {
    return el.closest('.product-card');
  }

  function getTrack(card) {
    return card ? card.querySelector('.product-card-track') : null;
  }

  function getSwatches(card) {
    return card ? card.querySelectorAll('.product-card-swatch') : [];
  }

  function getDots(card) {
    return card ? card.querySelectorAll('.product-card-dot') : [];
  }

  function setActiveIndex(card, index, behavior) {
    var track = getTrack(card);
    if (!track) return;
    var frame = track.clientWidth;
    if (!frame) return;
    track.scrollTo({ left: index * frame, behavior: behavior || 'auto' });
    updateActiveUI(card, index);
  }

  function updateActiveUI(card, index) {
    getSwatches(card).forEach(function (swatch) {
      var i = parseInt(swatch.getAttribute('data-index'), 10);
      swatch.classList.toggle('active', i === index);
    });
    getDots(card).forEach(function (dot, i) {
      dot.classList.toggle('active', i === index);
    });
  }

  function indexFromScroll(track) {
    var frame = track.clientWidth;
    if (!frame) return 0;
    return Math.round(track.scrollLeft / frame);
  }

  /* ========= HOVER (pointer: fine only) =========
     mouseover/mouseout bubble, so document-level delegation works without
     the capture flag mouseenter/mouseleave would need. relatedTarget tells
     us whether the pointer is still inside the same swatch/card. */
  document.addEventListener('mouseover', function (e) {
    if (!pointerFine) return;
    var swatch = e.target.closest && e.target.closest('.product-card-swatch');
    if (!swatch || swatch.contains(e.relatedTarget)) return;
    var card = getCard(swatch);
    if (!getTrack(card)) return;
    var timer = restoreTimers.get(card);
    if (timer) { clearTimeout(timer); restoreTimers.delete(card); }
    var index = parseInt(swatch.getAttribute('data-index'), 10) || 0;
    setActiveIndex(card, index, 'auto');
  });

  document.addEventListener('mouseout', function (e) {
    if (!pointerFine) return;
    var card = e.target.closest && e.target.closest('.product-card');
    if (!card || !getTrack(card)) return;
    var related = e.relatedTarget;
    if (related && card.contains(related)) return;
    var timer = setTimeout(function () {
      setActiveIndex(card, 0, 'auto');
      restoreTimers.delete(card);
    }, RESTORE_DELAY);
    restoreTimers.set(card, timer);
  });

  /* ========= CLICK: swatch tap-to-preview, tap-again-to-open ========= */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.product-card-swatch');
    if (swatch) {
      var card = getCard(swatch);
      if (!getTrack(card)) return;
      e.preventDefault();
      if (swatch.classList.contains('active')) {
        window.location.href = swatch.getAttribute('data-url');
        return;
      }
      var index = parseInt(swatch.getAttribute('data-index'), 10) || 0;
      setActiveIndex(card, index, 'auto');
      return;
    }

    /* ========= CLICK: nav prev/next (sit inside the <a>, stop the link) ========= */
    var nav = e.target.closest && e.target.closest('.product-card-nav');
    if (nav) {
      var navCard = getCard(nav);
      var track = getTrack(navCard);
      if (!track) return;
      e.preventDefault();
      e.stopPropagation();
      var count = parseInt(track.getAttribute('data-count'), 10) || track.children.length;
      if (!count) return;
      var current = indexFromScroll(track);
      var next = nav.classList.contains('next') ? current + 1 : current - 1;
      if (next < 0) next = count - 1;
      if (next >= count) next = 0;
      setActiveIndex(navCard, next, 'auto');
    }
  });

  /* ========= TRACK SCROLL (passive, rAF-throttled) ========= */
  var rafPending = new WeakMap();

  function onTrackScroll(track) {
    var card = getCard(track);
    if (!card) return;
    updateActiveUI(card, indexFromScroll(track));
  }

  function scheduleUpdate(track) {
    if (rafPending.get(track)) return;
    rafPending.set(track, true);
    window.requestAnimationFrame(function () {
      rafPending.set(track, false);
      onTrackScroll(track);
    });
  }

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.classList || !track.classList.contains('product-card-track')) return;
    scheduleUpdate(track);
  }, { capture: true, passive: true });

  document.addEventListener('scrollend', function (e) {
    var track = e.target;
    if (!track || !track.classList || !track.classList.contains('product-card-track')) return;
    onTrackScroll(track);
  }, { capture: true, passive: true });
})();
